<template>
<div id="auth">
    Пожалуйста подождите, идет инициализация соединения
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'auth',
  props: ['city', 'user', 'auth', 'service', 'leads'],
  created () {
    var login = this.$route.params.email
    var check1 = this.$route.params.check_1
    var check2 = this.$route.params.check_2
    this.autoLogin(login, check1, check2)
  },
  methods: {
    autoLogin (login, check1, check2) {
      if (this.user.uid) {
        if (login && check1 && check2) {
          var formData = new FormData()
          formData.append('login', login)
          formData.append('check1', check1)
          formData.append('check2', check2)
          formData.append('uid', this.user.uid)
          axios.post('https://crm.v-avtoservice.com/list/site-auth-api',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function (response) {
            console.log(response.data)
            if (response.data.title) alert(response.data.text)
            else window.location.href = '/cabinet/'
          })
            .catch(function () {
            })
        }
      } else {
        setTimeout(() => {
          this.autoLogin(login, check1, check2)
        }, 500)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/auth.vue